// extracted by mini-css-extract-plugin
module.exports = {"IsolatedScriptFrame___hasContent":"IsolatedScriptFrame_IsolatedScriptFrame___hasContent__bFKSl","IsolatedScriptFrame_frame":"IsolatedScriptFrame_IsolatedScriptFrame_frame__LGMnF"};